<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :id="iconName"
    :color="color"
  >
    <title :id="iconName">{{iconName}}</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
    >
      <g
        id="RetVejkode-kort-unfold"
        transform="translate(-1357.000000, -465.000000)"
        v-bind:stroke="color"
        stroke-width="2"
      >
        <g
          id="Group-14"
          transform="translate(1344.000000, 309.000000)"
        >
          <g
            id="Group-13"
            transform="translate(0.000000, 143.735771)"
          >
            <g
              id="Group-9"
              transform="translate(14.000000, 13.000000)"
            >
              <path
                d="M4.93210648,-1.11111111 L5.06789352,11.1111111"
                id="Line-4"
                transform="translate(5.000000, 5.000000) rotate(-45.000000) translate(-5.000000, -5.000000) "
              ></path>
              <path
                d="M-1.11111111,5.20132115 L11.1111111,4.79867885"
                id="Line-6"
                transform="translate(5.000000, 5.000000) rotate(-45.000000) translate(-5.000000, -5.000000) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'close',
    },
    color: {
      type: String,
      default: '#FFFFFF',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px;
}
</style>
